import { CustomerType as ModalCustomerType } from '@features/contacts/enums/customerType'
import { ContactType } from '@features/contacts/types/contactType'

export const customerModalTypeMap = {
  [ContactType.Person]: ModalCustomerType.Individual,
  [ContactType.Company]: ModalCustomerType.Company,
}
